import { render, staticRenderFns } from "./WithdrawalManagement.vue?vue&type=template&id=74a6210c&scoped=true"
import script from "./WithdrawalManagement.vue?vue&type=script&lang=js"
export * from "./WithdrawalManagement.vue?vue&type=script&lang=js"
import style0 from "./WithdrawalManagement.vue?vue&type=style&index=0&id=74a6210c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a6210c",
  null
  
)

export default component.exports